import { SyntheticEvent, useState } from 'react';
import { TextField, Autocomplete as MuiAutocomplete } from '@mui/material';

import useAuthStore, { ProfileWithExtendedData } from '@store/AuthStore';

import { isAlreadyGraduated } from '@utils/studentProgress';

import { gradeOptions } from '@constants/gradeOptions';

import { renderNoOptionsText } from '@components/Form/Autocomplete/Autocomplete';

import { AutocompleteOption } from '@interfaces';

interface GradeAutocompleteProps {
  handleGradeChange: (grade: string | undefined) => void;
}

export const GradeAutocomplete = (props: GradeAutocompleteProps) => {
  const { handleGradeChange } = props;

  const { userData } = useAuthStore((state) => state.authSession);
  const { gradeLevel } = (userData?.profile ?? {}) as ProfileWithExtendedData;

  const alreadyGraduated = isAlreadyGraduated();

  const defaultOption = gradeOptions.find(
    (option) => option.value === (alreadyGraduated ? '-1' : gradeLevel?.toString()),
  );

  const [grade, setGrade] = useState<AutocompleteOption | null>(defaultOption || null);

  const onGradeChange = (event: SyntheticEvent, grade: AutocompleteOption | null) => {
    setGrade(grade);

    handleGradeChange(grade?.value);
  };

  return (
    <MuiAutocomplete
      data-testid="gradeAutocomplete"
      options={gradeOptions}
      renderInput={(params) => <TextField {...params} label="What grade are you in?" />}
      clearIcon={null}
      value={grade}
      onChange={onGradeChange}
      noOptionsText={renderNoOptionsText()}
      isOptionEqualToValue={(option, value) => option.value === value.value}
    />
  );
};
